import script from "./diamondsSearchResultDiamond.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchResultDiamond.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchResultDiamond.vue?vue&type=style&index=0&id=ad5b1c72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad5b1c72"]])

export default __exports__